import { useCallback, useEffect, useState } from "react";
import {
  createWelcomeDrawerIsTopicLearningBased,
  fetchWelcomeDrawerTopicLibrary,
} from "pages/Welcome/welcomeDrawerReviewFeedbackTopics";

/**
 * Lifted ReviewItem feedback state — mirrors Dashboard ReviewsList for drawer parity.
 */
export function useWelcomeDrawerReviewFeedbackState(feedbackModeEnabled) {
  const [selectionIsFromSameReview, setSelectionIsFromSameReview] = useState(null);
  const [allReviewsIntents, setAllReviewsIntents] = useState({});
  const [pageChanged, setPageChanged] = useState(false);
  const [prevDeletionKey, setPrevDeletionKey] = useState(null);
  const [prevSelectionKey, setPrevSelectionKey] = useState(null);
  const [highlightedText, setHighlightedText] = useState({});
  const [deletedTopics, setDeletedTopics] = useState({});
  const [deletedIntents, setDeletedIntents] = useState({});
  const [publish, setPublish] = useState({});
  const [openCase, setOpenCase] = useState({});
  const [action, setAction] = useState({});
  const [prevClassifierKey, setPrevClassifierKey] = useState(null);
  const [decisionTags, setDecisionTags] = useState({});
  const [allTopics, setAllTopics] = useState([]);
  const [levelWiseTopics, setLevelWiseTopics] = useState([]);

  useEffect(() => {
    if (!feedbackModeEnabled) {
      setHighlightedText({});
      return undefined;
    }
    let cancelled = false;
    fetchWelcomeDrawerTopicLibrary().then(({ levelWiseTopics: tree, allTopics: flat }) => {
      if (cancelled) return;
      setLevelWiseTopics(tree);
      setAllTopics(flat);
    });
    return () => {
      cancelled = true;
    };
  }, [feedbackModeEnabled]);

  const isTopicLearningBased = useCallback(
    createWelcomeDrawerIsTopicLearningBased(levelWiseTopics),
    [levelWiseTopics],
  );

  return {
    selectionIsFromSameReview,
    setSelectionIsFromSameReview,
    allReviewsIntents,
    setAllReviewsIntents,
    pageChanged,
    setPageChanged,
    prevDeletionKey,
    setPrevDeletionKey,
    prevSelectionKey,
    setPrevSelectionKey,
    highlightedText,
    setHighlightedText,
    deletedTopics,
    setDeletedTopics,
    deletedIntents,
    setDeletedIntents,
    publish,
    setPublish,
    openCase,
    setOpenCase,
    action,
    setAction,
    prevClassifierKey,
    setPrevClassifierKey,
    decisionTags,
    setDecisionTags,
    allTopics,
    levelWiseTopics,
    isTopicLearningBased,
  };
}
